// ----------------------------------------------------------------------------
// Component: Author Archive
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_author-archive.scss';